(function () {
/**
 * Note the code in this file was cobbled together from the
 * original old version of the site (from around 2010) and
 * converted to Typescript without any major refactoring.
 */ function $14c571840e589f0e$var$asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) resolve(value);
    else Promise.resolve(value).then(_next, _throw);
}
function $14c571840e589f0e$export$71511d61b312f219(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                $14c571840e589f0e$var$asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                $14c571840e589f0e$var$asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}


function $daac50d2f5864f61$export$71511d61b312f219(thisArg, body) {
    var f, y, t, _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype), d = Object.defineProperty;
    return d(g, "next", {
        value: verb(0)
    }), d(g, "throw", {
        value: verb(1)
    }), d(g, "return", {
        value: verb(2)
    }), typeof Symbol === "function" && d(g, Symbol.iterator, {
        value: function() {
            return this;
        }
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}


function $bcce38db0d2b4516$export$71511d61b312f219(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}


function $53f3ce6e74f6aaad$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $53f3ce6e74f6aaad$export$71511d61b312f219(Constructor, protoProps, staticProps) {
    if (protoProps) $53f3ce6e74f6aaad$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $53f3ce6e74f6aaad$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}



function $7b161889ca248e24$export$71511d61b312f219(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}


function $f8a29d58f287cd3d$export$71511d61b312f219(arr) {
    if (Array.isArray(arr)) return (0, $7b161889ca248e24$export$71511d61b312f219)(arr);
}


function $b0c62864eda90b51$export$71511d61b312f219(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}


function $cf17359bdd687909$export$71511d61b312f219() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}



function $d6f91c356a8197fd$export$71511d61b312f219(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return (0, $7b161889ca248e24$export$71511d61b312f219)(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return (0, $7b161889ca248e24$export$71511d61b312f219)(o, minLen);
}


function $4c858c0d999a5b9b$export$71511d61b312f219(arr) {
    return (0, $f8a29d58f287cd3d$export$71511d61b312f219)(arr) || (0, $b0c62864eda90b51$export$71511d61b312f219)(arr) || (0, $d6f91c356a8197fd$export$71511d61b312f219)(arr) || (0, $cf17359bdd687909$export$71511d61b312f219)();
}


var $4a35b05c93511915$export$2e2bcd8739ae039 = function EventEmitter() {
    "use strict";
    var _this = this;
    var _this1 = this;
    (0, $bcce38db0d2b4516$export$71511d61b312f219)(this, EventEmitter);
    this.listeners = {};
    this.on = function(event, listener) {
        var _this_listeners_event;
        _this.listeners[event] = (0, $4c858c0d999a5b9b$export$71511d61b312f219)((_this_listeners_event = _this.listeners[event]) !== null && _this_listeners_event !== void 0 ? _this_listeners_event : []).concat([
            listener
        ]);
        return {
            dispose: function() {
                _this.off(event, listener);
            }
        };
    };
    this.off = function(event, listener) {
        var _this_listeners_event, _this_listeners_event1;
        var _this_listeners_event_indexOf;
        var callbackIndex = (_this_listeners_event_indexOf = (_this_listeners_event = _this.listeners[event]) === null || _this_listeners_event === void 0 ? void 0 : _this_listeners_event.indexOf(listener)) !== null && _this_listeners_event_indexOf !== void 0 ? _this_listeners_event_indexOf : -1;
        if (callbackIndex > -1) (_this_listeners_event1 = _this.listeners[event]) === null || _this_listeners_event1 === void 0 ? void 0 : _this_listeners_event1.splice(callbackIndex, 1);
    };
    this.emit = function(event) {
        for(var _len = arguments.length, payload = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
            payload[_key - 1] = arguments[_key];
        }
        var _this_listeners_event;
        return (_this_listeners_event = _this1.listeners[event]) === null || _this_listeners_event === void 0 ? void 0 : _this_listeners_event.forEach(function(listener) {
            return listener(payload[0]);
        });
    };
};


var $a8880305110bc4a7$var$getIdFromYoutubeUrl = function(url) {
    var _url_match;
    var re = /^(https?:\/\/)?((www\.)?(youtube(-nocookie)?|youtube.googleapis)\.com.*(v\/|v=|vi=|vi\/|e\/|embed\/|user\/.*\/u\/\d+\/)|youtu\.be\/)([_0-9a-z-]+)/i;
    return (_url_match = url.match(re)) === null || _url_match === void 0 ? void 0 : _url_match[7];
};
var $a8880305110bc4a7$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    "use strict";
    function Player() {
        var _this = this;
        (0, $bcce38db0d2b4516$export$71511d61b312f219)(this, Player);
        this.playheadInterval = 0;
        this.endSeconds = null;
        this.playerReady = false;
        this.ytPlayer = null;
        ///////////////////////////////
        //           EVENTS
        ///////////////////////////////
        this.onPlayerError = function(event) {
            _this.emitter.emit('error', {
                event: event
            });
        };
        this.onPlayerReady = function(event) {
            console.log('Player is ready');
            _this.playerReady = true;
            _this.ytPlayer = event.target;
            _this.emitter.emit('ready', {
                event: event
            });
        };
        this.onPlayerStateChange = function(event) {
            switch(event.data){
                case YT.PlayerState.PLAYING:
                    console.log("Player state change: playing");
                    _this.startPlayhead();
                    _this.emitter.emit('playing', {
                        event: event
                    });
                    break;
                case YT.PlayerState.ENDED:
                    console.log("Player state change: ended");
                    _this.stopPlayhead();
                    _this.emitter.emit('ended', {
                        event: event
                    });
                    break;
                case YT.PlayerState.PAUSED:
                    console.log("Player state change: paused");
                    _this.stopPlayhead();
                    _this.emitter.emit('paused', {
                        event: event
                    });
                    break;
                case YT.PlayerState.BUFFERING:
                    console.log("Player state change: buffering");
                    _this.stopPlayhead();
                    _this.emitter.emit('buffering', {
                        event: event
                    });
                    break;
                case YT.PlayerState.CUED:
                    console.log("Player state change: cued");
                    _this.emitter.emit('cued', {
                        event: event
                    });
                    break;
                case YT.PlayerState.UNSTARTED:
                    console.log("Player state change: unstarted");
                default:
                    break;
            }
        };
        this.emitter = new (0, $4a35b05c93511915$export$2e2bcd8739ae039)();
        this.on = this.emitter.on;
        this.off = this.emitter.off;
    }
    (0, $53f3ce6e74f6aaad$export$71511d61b312f219)(Player, [
        {
            ///////////////////////////////
            //          PLAYHEAD
            ///////////////////////////////
            key: "startPlayhead",
            value: function startPlayhead() {
                this.playheadInterval = setInterval(this.updatePlayhead, 100);
            }
        },
        {
            key: "stopPlayhead",
            value: function stopPlayhead() {
                clearInterval(this.playheadInterval);
            }
        },
        {
            key: "updatePlayhead",
            value: function updatePlayhead() {
                var _this_ytPlayer;
                if (typeof ((_this_ytPlayer = this.ytPlayer) === null || _this_ytPlayer === void 0 ? void 0 : _this_ytPlayer.getCurrentTime()) == 'undefined') {
                    clearInterval(this.playheadInterval);
                    return;
                }
                var playerCurrentTime = this.ytPlayer.getCurrentTime();
                if (this.endSeconds !== null && playerCurrentTime >= this.endSeconds) {
                    this.endSeconds = null;
                    this.stop();
                }
            }
        },
        {
            key: "seekToPercent",
            value: function seekToPercent(percent) {
                var _this_ytPlayer, _this_ytPlayer1;
                var _this_ytPlayer_getDuration;
                var time = percent * ((_this_ytPlayer_getDuration = (_this_ytPlayer = this.ytPlayer) === null || _this_ytPlayer === void 0 ? void 0 : _this_ytPlayer.getDuration()) !== null && _this_ytPlayer_getDuration !== void 0 ? _this_ytPlayer_getDuration : 0);
                (_this_ytPlayer1 = this.ytPlayer) === null || _this_ytPlayer1 === void 0 ? void 0 : _this_ytPlayer1.seekTo(time, true);
            }
        },
        {
            ///////////////////////////////
            //       CORE FUNCTIONS
            ///////////////////////////////
            key: "isReady",
            value: function isReady() {
                return this.playerReady;
            }
        },
        {
            key: "play",
            value: function play() {
                var _this = this;
                var reset = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : false;
                var _this_ytPlayer, _this_ytPlayer1;
                if (!this.isReady()) {
                    this.on("ready", function() {
                        _this.play(reset);
                    });
                    return;
                }
                if (reset) (_this_ytPlayer = this.ytPlayer) === null || _this_ytPlayer === void 0 ? void 0 : _this_ytPlayer.seekTo(0, true);
                (_this_ytPlayer1 = this.ytPlayer) === null || _this_ytPlayer1 === void 0 ? void 0 : _this_ytPlayer1.playVideo();
            }
        },
        {
            key: "stop",
            value: function stop1() {
                var _this_ytPlayer;
                if (!this.isReady()) {
                    this.on("ready", function() {
                        stop();
                    });
                    return;
                }
                (_this_ytPlayer = this.ytPlayer) === null || _this_ytPlayer === void 0 ? void 0 : _this_ytPlayer.stopVideo();
            }
        },
        {
            key: "pause",
            value: function pause() {
                var _this = this;
                var _this_ytPlayer;
                if (!this.isReady()) {
                    this.on("ready", function() {
                        _this.pause();
                    });
                    return;
                }
                (_this_ytPlayer = this.ytPlayer) === null || _this_ytPlayer === void 0 ? void 0 : _this_ytPlayer.pauseVideo();
            }
        },
        {
            key: "unPause",
            value: function unPause() {
                var _this = this;
                var _this_ytPlayer;
                if (!this.isReady()) {
                    this.on("ready", function() {
                        _this.unPause();
                    });
                    return;
                }
                (_this_ytPlayer = this.ytPlayer) === null || _this_ytPlayer === void 0 ? void 0 : _this_ytPlayer.playVideo();
            }
        },
        {
            key: "togglePause",
            value: function togglePause() {
                var _this_ytPlayer, _this_ytPlayer1;
                if (!this.isReady()) return;
                if (this.isPaused()) (_this_ytPlayer = this.ytPlayer) === null || _this_ytPlayer === void 0 ? void 0 : _this_ytPlayer.playVideo();
                else (_this_ytPlayer1 = this.ytPlayer) === null || _this_ytPlayer1 === void 0 ? void 0 : _this_ytPlayer1.pauseVideo();
            }
        },
        {
            key: "isPaused",
            value: function isPaused() {
                if (!this.isReady()) return false;
                return this.getState() == YT.PlayerState.PAUSED;
            }
        },
        {
            key: "isPlaying",
            value: function isPlaying() {
                if (!this.isReady()) return false;
                return this.getState() == YT.PlayerState.PLAYING;
            }
        },
        {
            key: "getState",
            value: function getState() {
                var _this_ytPlayer;
                var _this_ytPlayer_getPlayerState;
                return (_this_ytPlayer_getPlayerState = (_this_ytPlayer = this.ytPlayer) === null || _this_ytPlayer === void 0 ? void 0 : _this_ytPlayer.getPlayerState()) !== null && _this_ytPlayer_getPlayerState !== void 0 ? _this_ytPlayer_getPlayerState : YT.PlayerState.UNSTARTED;
            }
        },
        {
            key: "cueVideoById",
            value: function cueVideoById(videoId, startSeconds, suggestedQuality) {
                var _this = this;
                var _this_ytPlayer;
                if (!this.isReady()) {
                    this.on("ready", function() {
                        _this.cueVideoById(videoId, startSeconds, suggestedQuality);
                    });
                    return;
                }
                (_this_ytPlayer = this.ytPlayer) === null || _this_ytPlayer === void 0 ? void 0 : _this_ytPlayer.cueVideoById(videoId, startSeconds, suggestedQuality);
            }
        },
        {
            key: "cueVideoByUrl",
            value: function cueVideoByUrl(videoUrl, startSeconds, suggestedQuality) {
                var id = $a8880305110bc4a7$var$getIdFromYoutubeUrl(videoUrl);
                if (!id) throw new Error('Failed to extract ID for videoUrl ' + videoUrl);
                this.cueVideoById(id, startSeconds, suggestedQuality);
            }
        },
        {
            key: "loadVideoById",
            value: function loadVideoById(videoId, startSeconds, suggestedQuality) {
                var _this = this;
                var _this_ytPlayer;
                console.log('loadVideoById', videoId, startSeconds, suggestedQuality);
                if (!this.isReady()) {
                    console.log('Player is not ready');
                    this.on("ready", function() {
                        console.log('After ready triggered', videoId);
                        _this.loadVideoById(videoId, startSeconds, suggestedQuality);
                    });
                    return;
                }
                (_this_ytPlayer = this.ytPlayer) === null || _this_ytPlayer === void 0 ? void 0 : _this_ytPlayer.loadVideoById(videoId, startSeconds, suggestedQuality);
            }
        },
        {
            key: "loadVideoByUrl",
            value: function loadVideoByUrl(videoUrl, startSeconds, suggestedQuality) {
                var id = $a8880305110bc4a7$var$getIdFromYoutubeUrl(videoUrl);
                if (!id) throw new Error('Failed to extract ID for videoUrl ' + videoUrl);
                this.loadVideoById(id, startSeconds, suggestedQuality);
            }
        },
        {
            key: "getCurrentTime",
            value: function getCurrentTime() {
                var _this_ytPlayer;
                var _this_ytPlayer_getCurrentTime;
                return (_this_ytPlayer_getCurrentTime = (_this_ytPlayer = this.ytPlayer) === null || _this_ytPlayer === void 0 ? void 0 : _this_ytPlayer.getCurrentTime()) !== null && _this_ytPlayer_getCurrentTime !== void 0 ? _this_ytPlayer_getCurrentTime : 0;
            }
        },
        {
            key: "getDuration",
            value: function getDuration() {
                var _this_ytPlayer;
                var _this_ytPlayer_getDuration;
                return (_this_ytPlayer_getDuration = (_this_ytPlayer = this.ytPlayer) === null || _this_ytPlayer === void 0 ? void 0 : _this_ytPlayer.getDuration()) !== null && _this_ytPlayer_getDuration !== void 0 ? _this_ytPlayer_getDuration : 0;
            }
        },
        {
            key: "seekTo",
            value: function seekTo(seconds, allowSeekAhead) {
                var _this_ytPlayer;
                (_this_ytPlayer = this.ytPlayer) === null || _this_ytPlayer === void 0 ? void 0 : _this_ytPlayer.seekTo(seconds, allowSeekAhead);
            }
        },
        {
            key: "clearVideo",
            value: function clearVideo() {
                var _this_ytPlayer;
                (_this_ytPlayer = this.ytPlayer) === null || _this_ytPlayer === void 0 ? void 0 : _this_ytPlayer.stopVideo();
            }
        },
        {
            key: "mute",
            value: function mute() {
                var _this = this;
                var _this_ytPlayer;
                if (!this.isReady()) {
                    this.on("ready", function() {
                        _this.mute();
                    });
                    return;
                }
                (_this_ytPlayer = this.ytPlayer) === null || _this_ytPlayer === void 0 ? void 0 : _this_ytPlayer.mute();
            }
        },
        {
            key: "unMute",
            value: function unMute() {
                var _this = this;
                var _this_ytPlayer;
                if (!this.isReady()) {
                    this.on("ready", function() {
                        _this.unMute();
                    });
                    return;
                }
                (_this_ytPlayer = this.ytPlayer) === null || _this_ytPlayer === void 0 ? void 0 : _this_ytPlayer.unMute();
            }
        },
        {
            key: "isMuted",
            value: function isMuted() {
                var _this_ytPlayer;
                var _this_ytPlayer_isMuted;
                return (_this_ytPlayer_isMuted = (_this_ytPlayer = this.ytPlayer) === null || _this_ytPlayer === void 0 ? void 0 : _this_ytPlayer.isMuted()) !== null && _this_ytPlayer_isMuted !== void 0 ? _this_ytPlayer_isMuted : false;
            }
        },
        {
            key: "toggleMute",
            value: function toggleMute() {
                if (this.isMuted()) this.unMute();
                else this.mute();
            }
        },
        {
            key: "setVolume",
            value: function setVolume(volume) {
                var _this = this;
                var _this_ytPlayer;
                if (!this.isReady()) {
                    this.on("ready", function() {
                        _this.setVolume(volume);
                    });
                    return;
                }
                (_this_ytPlayer = this.ytPlayer) === null || _this_ytPlayer === void 0 ? void 0 : _this_ytPlayer.setVolume(volume);
            }
        },
        {
            key: "getVolume",
            value: function getVolume() {
                var _this_ytPlayer;
                var _this_ytPlayer_getVolume;
                return (_this_ytPlayer_getVolume = (_this_ytPlayer = this.ytPlayer) === null || _this_ytPlayer === void 0 ? void 0 : _this_ytPlayer.getVolume()) !== null && _this_ytPlayer_getVolume !== void 0 ? _this_ytPlayer_getVolume : 100;
            }
        }
    ]);
    return Player;
}();




//const baseUrl = 'http://localhost:8787/api/data/' // Default local dev url of ../api project
var $06ca4b51228a00cc$var$baseUrl = 'https://api.ragereplay.com/api/data/' // Must have trailing slash
;
var $06ca4b51228a00cc$var$dataIndex = {
    playlists: []
};
var $06ca4b51228a00cc$export$c0933877973da308 = function() {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $14c571840e589f0e$export$71511d61b312f219)(function() {
        var response, data;
        return (0, $daac50d2f5864f61$export$71511d61b312f219)(this, function(_state) {
            switch(_state.label){
                case 0:
                    if ($06ca4b51228a00cc$var$dataIndex.playlists.length) return [
                        2,
                        Promise.resolve($06ca4b51228a00cc$var$dataIndex)
                    ];
                    return [
                        4,
                        fetch($06ca4b51228a00cc$var$baseUrl + 'index.json')
                    ];
                case 1:
                    response = _state.sent();
                    if (!response.ok) throw new Error("Failed to load playlist index: ".concat(response.statusText));
                    return [
                        4,
                        response.json()
                    ];
                case 2:
                    data = _state.sent();
                    $06ca4b51228a00cc$var$dataIndex = data;
                    return [
                        2,
                        data
                    ];
            }
        });
    })();
};
var $06ca4b51228a00cc$export$b9347112ad6b5fab = function(path) {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $14c571840e589f0e$export$71511d61b312f219)(function() {
        var response, data;
        return (0, $daac50d2f5864f61$export$71511d61b312f219)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        fetch($06ca4b51228a00cc$var$baseUrl + path)
                    ];
                case 1:
                    response = _state.sent();
                    if (!response.ok) throw new Error("Failed to load playlist ".concat(path, ": ").concat(response.statusText));
                    return [
                        4,
                        response.json()
                    ];
                case 2:
                    data = _state.sent();
                    return [
                        2,
                        data
                    ];
            }
        });
    })();
};






//const baseUrl = 'http://localhost:8787/api/' // Default local dev url of ../api project
var $01cf4ed9cbd980a7$var$baseUrl = 'https://api.ragereplay.com/api/' // Must have trailing slash
;
var $01cf4ed9cbd980a7$export$bd80cdd36f597791 = function(artist, song) {
    return new Promise(function(resolve, reject) {
        $.ajax({
            method: 'GET',
            url: $01cf4ed9cbd980a7$var$baseUrl + 'musicvideosearch',
            dataType: 'json',
            data: {
                artist: artist,
                song: song
            },
            success: function(data) {
                return resolve(data);
            },
            error: function(_jqXHR, textStatus, errorThrown) {
                reject(textStatus + ': ' + errorThrown);
            }
        });
    });
};



var $d0c3271c451fac29$export$3748a2f1ceae9e24 = /*#__PURE__*/ function() {
    "use strict";
    function SourceList() {
        (0, $bcce38db0d2b4516$export$71511d61b312f219)(this, SourceList);
        this.pos = -1;
        this.sourcelist = [];
        this.emitter = new (0, $4a35b05c93511915$export$2e2bcd8739ae039)();
        this.on = this.emitter.on;
        this.off = this.emitter.off;
    }
    (0, $53f3ce6e74f6aaad$export$71511d61b312f219)(SourceList, [
        {
            key: "add",
            value: function add(videoInfo) {
                this.sourcelist.push(videoInfo);
            }
        },
        {
            key: "next",
            value: function next() {
                if (!this.hasNext()) return null;
                this.pos++;
                this.emitter.emit('change');
                return this.sourcelist[this.pos];
            }
        },
        {
            key: "prev",
            value: function prev() {
                if (!this.hasPrev()) return null;
                this.pos--;
                this.emitter.emit('change');
                return this.sourcelist[this.pos];
            }
        },
        {
            key: "hasNext",
            value: function hasNext() {
                return this.pos < this.sourcelist.length - 1;
            }
        },
        {
            key: "hasPrev",
            value: function hasPrev() {
                return this.pos > 0;
            }
        },
        {
            key: "seek",
            value: function seek(pos) {
                if (pos < 0 || pos > this.sourcelist.length) return;
                this.pos = pos;
                this.emitter.emit('change');
            }
        },
        {
            key: "indexOf",
            value: function indexOf(sourceListItem) {
                return this.sourcelist.indexOf(sourceListItem);
            }
        },
        {
            key: "current",
            value: function current() {
                if (this.pos < 0) return null;
                return this.sourcelist[this.pos];
            }
        },
        {
            key: "clear",
            value: function clear() {
                this.pos = -1;
                this.sourcelist = [];
                this.emitter.emit('cleared');
            }
        },
        {
            //sets the current source as invalid/error
            key: "setCurrentError",
            value: function setCurrentError() {
                if (this.pos < 0) return;
                this.sourcelist[this.pos].error = true;
            }
        },
        {
            key: "load",
            value: /**
   * Clears sources list and loads new sources from the API.
   * @param track PlaylistTrack
   */ function load(track) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $14c571840e589f0e$export$71511d61b312f219)(function() {
                    var _this, sources, e;
                    return (0, $daac50d2f5864f61$export$71511d61b312f219)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _this = this;
                                this.clear();
                                this.emitter.emit('loadBegin', {
                                    track: track
                                });
                                _state.label = 1;
                            case 1:
                                _state.trys.push([
                                    1,
                                    3,
                                    ,
                                    4
                                ]);
                                return [
                                    4,
                                    (0, $01cf4ed9cbd980a7$export$bd80cdd36f597791)(track.artist, track.song)
                                ];
                            case 2:
                                sources = _state.sent();
                                sources.forEach(function(source) {
                                    var _source_title;
                                    _this.add({
                                        title: (_source_title = source.title) !== null && _source_title !== void 0 ? _source_title : 'Unknown title',
                                        url: source.url
                                    });
                                });
                                this.pos = 0;
                                this.emitter.emit('change');
                                this.emitter.emit('loadSuccess', {
                                    track: track
                                });
                                return [
                                    3,
                                    4
                                ];
                            case 3:
                                e = _state.sent();
                                this.emitter.emit('loadError', {
                                    track: track,
                                    error: e.message
                                });
                                return [
                                    3,
                                    4
                                ];
                            case 4:
                                return [
                                    2
                                ];
                        }
                    });
                }).call(this);
            }
        }
    ]);
    return SourceList;
}();





var $84d6f6cd7169a1ee$export$199631bfaacffce5 = /*#__PURE__*/ function(TrackChangeDirection) {
    TrackChangeDirection[TrackChangeDirection["FORWARD"] = 1] = "FORWARD";
    TrackChangeDirection[TrackChangeDirection["BACKWARD"] = -1] = "BACKWARD";
    TrackChangeDirection[TrackChangeDirection["NONE"] = 0] = "NONE";
    return TrackChangeDirection;
}({});
var $84d6f6cd7169a1ee$export$8931430458a8a419 = /*#__PURE__*/ function() {
    "use strict";
    function TrackList() {
        (0, $bcce38db0d2b4516$export$71511d61b312f219)(this, TrackList);
        this.max = 1000 // the playlist will never grow bigger than this
        ;
        this.pos = -1;
        this.playlist = [];
        this.emitter = new (0, $4a35b05c93511915$export$2e2bcd8739ae039)();
        this.on = this.emitter.on;
        this.off = this.emitter.off;
    }
    (0, $53f3ce6e74f6aaad$export$71511d61b312f219)(TrackList, [
        {
            // Adds track to end of the playlist
            // if the track param is an array then it will loop through and add each track
            key: "add",
            value: function add(track) {
                var _this = this;
                if (Array.isArray(track)) {
                    track.forEach(function(t) {
                        return _this.add(t);
                    });
                    return;
                }
                if (this.playlist.length >= this.max) {
                    this.playlist.shift() // remove first item from playlist
                    ;
                    if (this.pos >= 0) this.pos--;
                }
                this.playlist.push(track);
                this.emitter.emit('modified');
            }
        },
        {
            // Removes track from the playlist
            // returns the removed track or null
            key: "remove",
            value: function remove(track) {
                var index = this.playlist.indexOf(track);
                if (index != -1) {
                    var _$track = this.playlist.splice(index, 1);
                    if (this.pos > index && this.pos >= 0) this.pos--;
                    this.emitter.emit('modified');
                    return _$track[0];
                }
                return null;
            }
        },
        {
            // Returns the next track or null
            // updatePos: whether to automatically increment the playlist pos
            key: "next",
            value: function next() {
                var updatePos = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : true;
                if (!this.hasNext()) {
                    this.emitter.emit('finished');
                    return null;
                }
                var result = this.playlist[this.pos + 1];
                if (updatePos == true) {
                    this.pos++;
                    this.emitter.emit('change', {
                        current: this.playlist[this.pos],
                        previous: this.playlist[this.pos - 1],
                        direction: 1
                    });
                }
                return result;
            }
        },
        {
            // Returns the prev track or null
            // updatePos: whether to automatically decrement the playlist pos
            key: "prev",
            value: function prev() {
                var updatePos = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : true;
                if (!this.hasPrev()) return null;
                var result = this.playlist[this.pos - 1];
                if (updatePos == true) {
                    this.pos--;
                    this.emitter.emit('change', {
                        current: this.playlist[this.pos],
                        previous: this.playlist[this.pos + 1],
                        direction: -1
                    });
                }
                return result;
            }
        },
        {
            key: "hasNext",
            value: function hasNext() {
                return this.pos < this.playlist.length - 1;
            }
        },
        {
            key: "hasPrev",
            value: function hasPrev() {
                return this.pos > 0;
            }
        },
        {
            key: "current",
            value: function current() {
                if (this.pos < 0) return null;
                return this.playlist[this.pos];
            }
        },
        {
            key: "rewind",
            value: function rewind() {
                this.pos = 0;
                this.emitter.emit('change', {
                    current: this.playlist[this.pos],
                    previous: this.next(false),
                    direction: -1
                });
                return this.playlist[this.pos];
            }
        },
        {
            key: "fastForward",
            value: function fastForward() {
                this.pos = this.playlist.length - 1;
                this.emitter.emit('change', {
                    current: this.playlist[this.pos],
                    previous: this.prev(false),
                    direction: 1
                });
                return this.playlist[this.pos];
            }
        },
        {
            key: "skip",
            value: function skip(newPos) {
                if (typeof newPos == "undefined" || this.playlist[newPos] == undefined) {
                    console.log("Tracklist.skip() Position is not valid. Ignoring...");
                    return this.playlist[this.pos];
                }
                if (this.pos == newPos) return this.playlist[this.pos];
                var direction = 0;
                var secondaryTrack = null;
                if (newPos > this.pos) {
                    direction = 1;
                    secondaryTrack = this.next(false);
                } else {
                    direction = -1;
                    secondaryTrack = this.prev(false);
                }
                this.pos = newPos;
                this.emitter.emit('change', {
                    current: this.playlist[this.pos],
                    previous: secondaryTrack,
                    direction: direction
                });
                return this.playlist[this.pos];
            }
        },
        {
            // Returns the size of the playlist
            key: "length",
            value: function length() {
                return this.playlist.length;
            }
        },
        {
            key: "getPosition",
            value: function getPosition() {
                return this.pos;
            }
        },
        {
            // Returns how many tracks are yet to be played in the current playlist
            key: "upcomingLength",
            value: function upcomingLength() {
                return this.playlist.length - 1 - this.pos;
            }
        },
        {
            // Clears all the next tracks from the playlist
            key: "clearUpcoming",
            value: function clearUpcoming() {
                this.playlist = this.playlist.slice(0, this.pos + 1);
                this.emitter.emit('modified');
            }
        },
        {
            // Clear track history
            key: "clear",
            value: function clear() {
                this.playlist = [];
                this.pos = -1;
                this.emitter.emit('modified');
            }
        }
    ]);
    return TrackList;
}();


var $58f1aa7a409072fa$export$324699496a105db8 = function(rawStr) {
    return rawStr.replace(/[\u00A0-\u9999<>\&]/g, function(i) {
        return '&#' + i.charCodeAt(0) + ';';
    });
};
var $58f1aa7a409072fa$export$a1a11b095f88289a = $58f1aa7a409072fa$export$324699496a105db8;


var $f2827e7851f3fa53$var$formatSpecialTitle = function(title) {
    var toReplace = [
        'guest programs rage',
        'guest program rage',
        'guest programs',
        'guest program',
        'Guest Programs',
        'Grust Program'
    ];
    toReplace.forEach(function(str) {
        title = title.replace(str, '');
    });
    return title.charAt(0).toUpperCase() + title.substring(1, 30).trim();
};
function $f2827e7851f3fa53$export$2e2bcd8739ae039(_playlists) {
    var playlists = _playlists.slice().sort(function(a, b) {
        var _a_special, _b_special;
        return ((_a_special = a.special) !== null && _a_special !== void 0 ? _a_special : '').localeCompare((_b_special = b.special) !== null && _b_special !== void 0 ? _b_special : '');
    });
    var $el = $(document.createDocumentFragment());
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = playlists[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var playlist = _step.value;
            if (!playlist.special || playlist.special.startsWith('New Music')) continue;
            var id = playlist.path.replace('.json', '');
            $el.append('<p>\n        <a href="#/episode/'.concat((0, $58f1aa7a409072fa$export$a1a11b095f88289a)(id), '/1" class="playlist" data-playlist_id="').concat((0, $58f1aa7a409072fa$export$a1a11b095f88289a)(id), '">\n          ').concat((0, $58f1aa7a409072fa$export$a1a11b095f88289a)($f2827e7851f3fa53$var$formatSpecialTitle(playlist.special)), "\n        </a>\n      </p>"));
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return $el;
}


var $e2b3e6a926fe34e0$export$ed7e01d08fb37999 = function(number) {
    var selector;
    if (number <= 0) selector = 4;
    else if (number > 3 && number < 21 || number % 10 > 3) selector = 0;
    else selector = number % 10;
    return number + [
        'th',
        'st',
        'nd',
        'rd',
        ''
    ][selector];
};
var $e2b3e6a926fe34e0$export$2061056d06d7cdf7 = function(date) {
    var weekDays = [
        'Sun',
        'Mon',
        'Tue',
        'Wed',
        'Thu',
        'Fri',
        'Sat'
    ];
    return weekDays[date.getDay()];
};
var $e2b3e6a926fe34e0$export$c1d85b1285963efe = function(date) {
    var day = $e2b3e6a926fe34e0$export$ed7e01d08fb37999(date.getDate());
    var monthNames = [
        "January",
        "February",
        "March",
        "April",
        "May",
        "June",
        "July",
        "August",
        "September",
        "October",
        "November",
        "December"
    ];
    return "".concat(day, " ").concat(monthNames[date.getMonth()]);
};



function $f0dd997f1b5daa2a$export$2e2bcd8739ae039(_playlists) {
    var playlists = _playlists.slice().reverse();
    var $el = $(document.createDocumentFragment());
    var prevYear = null;
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = playlists[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var playlist = _step.value;
            var date = new Date(Date.parse(playlist.date));
            // @TODO - original code added one day to date if
            //         timeslot is morning, check if still required
            var year = date.getFullYear();
            if (prevYear != year) {
                $el.append('\n        <div class="clearfix"></div>\n        <a name="episode-'.concat(year, '"></a>\n        <h2><span>').concat(year, "</span></h2>"));
                prevYear = year;
            }
            var id = playlist.path.replace('.json', '');
            $el.append('<p>\n        <a href="#/episode/'.concat((0, $58f1aa7a409072fa$export$a1a11b095f88289a)(id), '/1"\n           class="playlist"\n           data-playlist_id="').concat((0, $58f1aa7a409072fa$export$a1a11b095f88289a)(id), '"\n           ').concat(playlist.special ? 'rel="tooltip" title="'.concat((0, $58f1aa7a409072fa$export$a1a11b095f88289a)(playlist.special), '" data-placement="top"') : '', '\n        >\n          <span style="color:#BBB; font-family:monospace;">').concat((0, $e2b3e6a926fe34e0$export$2061056d06d7cdf7)(date), "</span>\n          ").concat((0, $e2b3e6a926fe34e0$export$c1d85b1285963efe)(date), "\n          ").concat(playlist.special ? '<span class="label label-info">s</span>' : '', "\n        </a>\n      </p>"));
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return $el;
}


function $f3231d523fa2a92f$export$2e2bcd8739ae039() {
    var $el = $(document.createDocumentFragment());
    var startYear = 1999;
    var endYear = new Date().getFullYear();
    for(var year = startYear; year <= endYear; year++)$el.append('<li><a class="skip-to-year" data-year="'.concat(year, '" href="javascript:void(0)">').concat(year, "</a></li>"));
    return $el;
}


var $8359390af20d48a4$var$currentPlaylist = null;
var $8359390af20d48a4$var$trackList = new (0, $84d6f6cd7169a1ee$export$8931430458a8a419)();
var $8359390af20d48a4$var$sourceList = new (0, $d0c3271c451fac29$export$3748a2f1ceae9e24)();
var $8359390af20d48a4$var$player = new (0, $a8880305110bc4a7$export$2e2bcd8739ae039)();
window.onYouTubePlayerAPIReady = function() {
    new YT.Player('player', {
        height: '315',
        width: '560',
        videoId: 'ZzxKW6O8sNM',
        playerVars: {
            fs: 0,
            autoplay: 0,
            showinfo: 0,
            controls: 0,
            disablekb: 1,
            iv_load_policy: 3,
            modestbranding: 1,
            rel: 0,
            loop: 0
        },
        events: {
            onReady: $8359390af20d48a4$var$player.onPlayerReady,
            onStateChange: $8359390af20d48a4$var$player.onPlayerStateChange,
            onError: $8359390af20d48a4$var$player.onPlayerError
        }
    });
};
var $8359390af20d48a4$var$init = function() {
    // ROUTER
    var router = new Simrou({
        '/episode/top200': {
            get: function() {
                router.navigate("/episode/top200/1");
            }
        },
        '/episode/top200/:track': {
            get: function(_, param) {
                var track = param.track;
                $8359390af20d48a4$var$loadPlaylist('top200', function() {
                    $8359390af20d48a4$var$trackList.skip(track - 1);
                });
            }
        },
        '/episode/:year/:month/:day': {
            get: function(_, param) {
                var year = param.year, month = param.month, day = param.day;
                router.navigate("/episode/".concat(year, "/").concat(month, "/").concat(day, "/1"));
            }
        },
        '/episode/:year/:month/:day/:track': {
            get: function(_, param) {
                var year = param.year, month = param.month, day = param.day, track = param.track;
                $8359390af20d48a4$var$loadPlaylist("".concat(year, "/").concat(month, "/").concat(day), function() {
                    $8359390af20d48a4$var$trackList.skip(track - 1);
                });
            }
        },
        '/home': {
            get: function() {
                $8359390af20d48a4$var$player.play(true) //play intro video
                ;
            }
        }
    });
    window.onhashchange = function init() {
        router.navigate(window.location.hash);
    };
    // EPISODE/SPECIAL TAB
    $('body').on('click', '.nav .skip-to-year', function(_e) {
        var year = $(this).attr('data-year');
        var anchor = $('a[name=episode-' + year + ']');
        $('#pop-up-container').scrollTop(anchor.position().top);
    });
    $('.sort-by-date').on('click', function(_e) {
        $('#specials').hide();
        $('#episodes').show();
        $('.sort-by-date').parent().addClass('active');
        $('.sort-by-special').parent().removeClass('active');
        $('.skip-to-year-toggle').parent().removeClass('disabled');
    });
    $('.sort-by-special').on('click', function(_e) {
        $('#specials').show();
        $('#episodes').hide();
        $('.sort-by-date').parent().removeClass('active');
        $('.sort-by-special').parent().addClass('active');
        $('.skip-to-year-toggle').parent().addClass('disabled');
    });
    // Load playlist data, then render episodes tabs
    (0, $06ca4b51228a00cc$export$c0933877973da308)().then(function(data) {
        $('#episodes').empty().append((0, $f0dd997f1b5daa2a$export$2e2bcd8739ae039)(data.playlists));
        $('#specials').empty().append((0, $f2827e7851f3fa53$export$2e2bcd8739ae039)(data.playlists));
        $('#year-dropdown .dropdown-menu').append((0, $f3231d523fa2a92f$export$2e2bcd8739ae039)());
        $('[data-playlist-count]').text(data.playlists.length);
        $8359390af20d48a4$var$initTooltips();
    });
    // TOP MENU
    $('.episode-button').on('click', function(_e) {
        $8359390af20d48a4$var$changeTab('episodeList');
    });
    $('.now-playing-button').on('click', function(_e) {
        $8359390af20d48a4$var$changeTab('nowPlaying');
    });
    $('.player-backward').on('click', function(_e) {
        //trackList.prev()
        if ($8359390af20d48a4$var$trackList.hasPrev()) router.navigate('/episode/' + $8359390af20d48a4$var$currentPlaylist + '/' + $8359390af20d48a4$var$trackList.getPosition());
    });
    $('.player-forward').on('click', function(_e) {
        if ($8359390af20d48a4$var$trackList.hasNext()) router.navigate('/episode/' + $8359390af20d48a4$var$currentPlaylist + '/' + ($8359390af20d48a4$var$trackList.getPosition() + 2));
    });
    $('.player-pause').on('click', function(_e) {
        $8359390af20d48a4$var$player.togglePause();
    });
    if (!document.fullscreenEnabled) $('.player-fullscreen').hide();
    else $('.player-fullscreen').on('click', function(_e) {
        if (document.fullscreenElement) document.exitFullscreen();
        else document.documentElement.requestFullscreen({
            navigationUI: 'hide'
        });
    });
    ///// EVENTS /////
    $8359390af20d48a4$var$trackList.on('change', $8359390af20d48a4$var$onTrackChange);
    $8359390af20d48a4$var$trackList.on('finished', function() {
        return $8359390af20d48a4$var$changeTab('episodeList');
    });
    $8359390af20d48a4$var$sourceList.on('change', $8359390af20d48a4$var$onSourceChange);
    $8359390af20d48a4$var$sourceList.on('loadError', $8359390af20d48a4$var$onSourceListLoadFailed);
    $8359390af20d48a4$var$player.on('error', function(error) {
        var _sourceList_current;
        console.log('Failed to load video', (_sourceList_current = $8359390af20d48a4$var$sourceList.current()) === null || _sourceList_current === void 0 ? void 0 : _sourceList_current.url, error);
        $8359390af20d48a4$var$sourceList.setCurrentError();
        var result = $8359390af20d48a4$var$sourceList.next() // load next alt sources, until we have tried them all
        ;
        if (result === null) $8359390af20d48a4$var$trackList.next();
    });
    $8359390af20d48a4$var$player.on("ended", function() {
        return $8359390af20d48a4$var$trackList.next();
    });
    $8359390af20d48a4$var$player.on("paused", function() {
        $('.player-pause i').removeClass().addClass('icon-play');
    });
    $8359390af20d48a4$var$player.on("playing", function() {
        $('.player-pause i').removeClass().addClass('icon-pause');
    });
    ///// KEYBOARD SHORTCUTS /////
    $(document).on('keyup', function(e) {
        var key = e.which;
        //Left arrow
        if (key == 37) $8359390af20d48a4$var$trackList.prev();
        //Right arrow
        if (key == 39) $8359390af20d48a4$var$trackList.next();
        //Space bar
        if (key == 32) $8359390af20d48a4$var$player.togglePause();
        return true;
    });
    // Prevent default (i.e. scrolling) for the left and right arrow keys
    $(document).on('keydown', function(e) {
        var key = e.which;
        if (key == 37 || key == 39) {
            e.preventDefault();
            return false;
        }
        return true;
    });
    router.start('/home');
};
var $8359390af20d48a4$var$loadPlaylist = function loadPlaylist(id, callback) {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $14c571840e589f0e$export$71511d61b312f219)(function() {
        var path, data, error;
        return (0, $daac50d2f5864f61$export$71511d61b312f219)(this, function(_state) {
            switch(_state.label){
                case 0:
                    if (typeof id == 'undefined') throw "RageAgain.loadPlaylist() id is undefined.";
                    path = id + '.json';
                    if ($8359390af20d48a4$var$currentPlaylist == id) {
                        if (typeof callback === 'function') callback($8359390af20d48a4$var$currentPlaylist);
                        return [
                            2
                        ];
                    }
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        3,
                        ,
                        4
                    ]);
                    return [
                        4,
                        (0, $06ca4b51228a00cc$export$b9347112ad6b5fab)(path)
                    ];
                case 2:
                    data = _state.sent();
                    $('#fullscreen-loader').hide();
                    if (!data || !data.tracks) {
                        alert('Failed to load selected playlist. No tracks found.');
                        return [
                            2
                        ];
                    }
                    $8359390af20d48a4$var$currentPlaylist = id;
                    $8359390af20d48a4$var$trackList.clear();
                    $8359390af20d48a4$var$trackList.add(data.tracks);
                    if (typeof callback === 'function') callback($8359390af20d48a4$var$currentPlaylist);
                    $('a span.now-playing-label').remove();
                    $('a[data-playlist_id="' + id + '"]').append('<span class="label label-important now-playing-label">p</span>');
                    $8359390af20d48a4$var$changeTab('nowPlaying');
                    return [
                        3,
                        4
                    ];
                case 3:
                    error = _state.sent();
                    console.error('Failed to load playlist', error);
                    return [
                        3,
                        4
                    ];
                case 4:
                    return [
                        2
                    ];
            }
        });
    })();
};
var $8359390af20d48a4$var$initTooltips = function() {
    $(document).tooltip({
        selector: 'a[rel=tooltip]',
        placement: function placement(_tooltip, target) {
            return $(target).attr('data-placement') || 'top';
        },
        trigger: 'manual'
    });
    var checkTooltipOffset = function() {
        var _$_children_offset;
        var leftOffset = (_$_children_offset = $('body').children('.tooltip').offset()) === null || _$_children_offset === void 0 ? void 0 : _$_children_offset.left;
        if ((leftOffset !== null && leftOffset !== void 0 ? leftOffset : 0) < 0) $('body').children('.tooltip').offset({
            left: 0
        });
    };
    $('a[rel=tooltip]').on('mouseenter', function(e) {
        $(this).tooltip('show');
        checkTooltipOffset();
        setTimeout(checkTooltipOffset, 100);
        e.preventDefault();
        e.stopImmediatePropagation();
    });
    $('a[rel=tooltip]').on('mouseleave', function(_e) {
        $(this).tooltip('hide');
    });
};
var $8359390af20d48a4$var$onTrackChange = function onTrackChange(param) {
    var curTrack = param.current;
    $8359390af20d48a4$var$sourceList.load(curTrack);
    $('#nav-right').fadeIn();
    $('.artist').text(curTrack.artist);
    $('.track').text(curTrack.song);
    document.title = "".concat(curTrack.song, " by ").concat(curTrack.artist, " | Rage Replay");
    if (curTrack.label) $('.tracklabel').text('(' + curTrack.label + ')');
    else $('.tracklabel').text('');
    $('#now-playing-info').hide().delay(1500).fadeIn('slow').delay(8000).fadeOut();
    if ($8359390af20d48a4$var$player.getState() == YT.PlayerState.UNSTARTED) $8359390af20d48a4$var$player.play();
};
var $8359390af20d48a4$var$onSourceListLoadFailed = function onSourceListLoadFailed() {
    console.log('onSourceListLoadFailed');
    var current = $8359390af20d48a4$var$trackList.current();
    // Remove this track and load next one
    // @TODO notify user that track failed to load
    if (current) {
        var _trackList_current, _trackList_current1;
        console.log("No sources available. Removing track...".concat((_trackList_current = $8359390af20d48a4$var$trackList.current()) === null || _trackList_current === void 0 ? void 0 : _trackList_current.song, " - ").concat((_trackList_current1 = $8359390af20d48a4$var$trackList.current()) === null || _trackList_current1 === void 0 ? void 0 : _trackList_current1.artist));
        $8359390af20d48a4$var$trackList.remove(current);
    }
    $8359390af20d48a4$var$trackList.next();
};
var $8359390af20d48a4$var$onSourceChange = function onSourceChange() {
    var _sourceList_current;
    console.log('onSourceChange');
    if ((_sourceList_current = $8359390af20d48a4$var$sourceList.current()) === null || _sourceList_current === void 0 ? void 0 : _sourceList_current.url) $8359390af20d48a4$var$player.loadVideoByUrl($8359390af20d48a4$var$sourceList.current().url);
};
var $8359390af20d48a4$var$changeTab = function changeTab(tabName) {
    if (tabName == 'episodeList') {
        $('header #nav-left a').removeClass('active');
        $('.episode-button').addClass('active');
        $('#overlay').fadeIn();
        $('#episode-container').show();
        $('#pop-up-container').show();
    } else if (tabName == 'nowPlaying') {
        $('header #nav-left a').removeClass('active');
        $('.now-playing-button').addClass('active');
        $('#overlay').fadeOut();
        $('#episode-container').hide();
        $('#pop-up-container').hide();
    }
};
function $8359390af20d48a4$export$2e2bcd8739ae039() {
    if (!!window.$ && !!window.Simrou) {
        $(function() {
            return $8359390af20d48a4$var$init();
        });
        return;
    }
    var timer = setInterval(function() {
        if (!!window.$ && !!window.Simrou) {
            clearInterval(timer);
            $(function() {
                return $8359390af20d48a4$var$init();
            });
        }
    }, 100);
}


(0, $8359390af20d48a4$export$2e2bcd8739ae039)();

})();
//# sourceMappingURL=web.6d712756.js.map
